module.exports = __webpack_public_path__ + "static/media/wine.7fb92899.svg";